




























































































































































import { snakeCase, cloneDeep } from 'lodash'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import HelpMessage from '../.../../../../HelpMessage/HelpMessage.vue'
import ModelSetter from '../../../../Mixins/ModelSetter'
import Icon from '../../../Icon/Icon.vue'
import { UseFields } from '../../../Pi'
import { getNewPropertyIcon, getPropertyTranslation, sortProperties } from '../../utils'
import CreateNewProperty from './CreateNewProperty.vue'
import { BotProperty } from './types'

@Component({
  data() {
    return {
      snakeCase,
      getNewPropertyIcon,
      getPropertyTranslation
    }
  },
  components: {
    HelpMessage,
    Icon,
    CreateNewProperty,
  }
})
export default class BotProperties extends Mixins(UseFields, ModelSetter) {
  @VModel() properties!: Array<BotProperty>

  @Prop() createProperty!: (path: string, name: string, parent?: number, data?: Record<string, any> | null) => Promise<Array<BotProperty>>

  @Prop() renameProperty!: (id: number, name: string) => Promise<Array<BotProperty>>

  @Prop() removeProperty!: (id: number) => Promise<Array<BotProperty>>

  currentCopy: BotProperty | null = null

  parent: BotProperty | null = null

  isOpen = false

  isCreateChildModalOpen = false

  createChildrenProperty(path: string, type: string) {
    this.createProperty(path, getPropertyTranslation(this.$i18n, type), this.parent!.id)
      .then(() => {
        this.isCreateChildModalOpen = false
      })
  }

  prepareAddChildProperty(parent: BotProperty) {
    this.parent = parent
    this.isCreateChildModalOpen = true
  }

  editProperty(record:BotProperty) {
    this.currentCopy = cloneDeep(record)
  }

  editProp(originalName:string): void {
    if (this.currentCopy) {
      if (this.currentCopy.name !== originalName && this.currentCopy.id && this.currentCopy.name) {
        this.renameProperty(this.currentCopy.id, this.currentCopy.name)
          .then(() => this.currentCopy = null)
      } else {
        this.currentCopy = null
      }
    }
  }

  removePropertyWarn(id: number) {
    this.$confirm({
      title: this.$t('remove_property_warn_title').toString(),
      content: this.$t('remove_property_warn_text').toString(),
      onOk: () => this.removeProperty(id)
    })
  }

  get preparedProperties(): Array<BotProperty & {children?: Array<BotProperty>}> {
    const setChildren = (properties: Array<BotProperty>): Array<BotProperty & {children?: Array<BotProperty>}> => {
      // children field for treeview in table
      if (properties.length) {
        return properties.map(p => ({
          ...p,
          ...p.properties.length ? {
            children: setChildren(p.properties),
          } : {}
        }))
      } else {
        return properties
      }
    }

    return setChildren(sortProperties(this.properties))
  }

}
